__turbopack_context__.v({
  "className": "atypdisaply_57d1b12-module__lcQ-Ca__className",
});
